// import React from 'react';
// import { Box, Grid, Typography, Card, CardContent, CardHeader, CardActionArea } from '@mui/material';
// import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import ListOperateur from './ListOperateur';
import ListVariables from './ListVariables';

// import { useAuth } from '../../contexts/AuthContext'; 

const Dashboard = () => {
    // const { isAuthenticated, userRole } = useAuth();

    // TODO : Vérifier l'état de l'utilisateur (isAuthenticated) et son rôle (userRole) pour afficher les éléments du dashboard en fonction de ses permissions :
    //     - si authentifié, sinon rediriger vers la page de login.
    //     - si admin, sinon rediriger vers la page de liste des simulations.
    return (
        <Box sx={{ flexGrow: 1, padding: 3, margin: '0 50px' }}>
            <ListOperateur />
            <ListVariables />
        </Box>
    );
};

export default Dashboard;
